module.exports = __webpack_public_path__ + "img/2x.4565d0f.jpg";